var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26108_2316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4555 6.998C21.5785 7.657 21.6455 8.346 21.6455 9.065C21.6455 14.689 17.8815 18.688 12.1965 18.688C10.9037 18.6884 9.62344 18.434 8.42894 17.9395C7.23443 17.4449 6.14908 16.7198 5.2349 15.8056C4.32072 14.8915 3.59563 13.8061 3.10107 12.6116C2.6065 11.4171 2.35215 10.1368 2.35254 8.844C2.35215 7.55116 2.6065 6.27091 3.10107 5.0764C3.59563 3.88189 4.32072 2.79654 5.2349 1.88236C6.14908 0.968184 7.23443 0.243095 8.42894 -0.251472C9.62344 -0.74604 10.9037 -1.00039 12.1965 -1C14.8545 -1 17.0755 -0.0219994 18.7795 1.566L16.0045 4.341V4.334C14.9715 3.35 13.6605 2.845 12.1965 2.845C8.94854 2.845 6.30854 5.589 6.30854 8.838C6.30854 12.086 8.94854 14.836 12.1965 14.836C15.1435 14.836 17.1495 13.151 17.5615 10.837H12.1965V6.998H21.4565H21.4555Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26108_2316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.a934cb01ddcc1808129a9e1d02733197.svg";
export { ForwardRef as ReactComponent };